// A Gap Analysis row only counts toward averages, counts and the readiness figure when it
// carries a real score: an AI score (both numbers present, not a failure fallback) or a
// human override of both. A row the AI never scored is "Not scored", never a 0/0.
export function aiRowHasScore(ai) {
  return !!ai && ai.aiFailed !== true && Number.isFinite(ai.readinessScore) && Number.isFinite(ai.expectedScore);
}

export function isGapRowScored(store, row) {
  if (!row) return false;
  if (row.scored !== false) return true;
  const o = store?.[row.id];
  return !!o && Number.isFinite(o.readinessScore) && Number.isFinite(o.expectedScore);
}

/** Rows whose domain is missing are shown under this label and excluded from per-domain figures. */
export const UNCLASSIFIED_DOMAIN = "Unclassified";

/**
 * Overall readiness percent computed from a scores map (e.g. the server's validate response) plus
 * the human overrides, counting only rows that carry a real score. null when nothing is scored.
 * `groups` = [{ rows: [{id}], overrides: {id: {readinessScore, expectedScore}} }].
 */
export function computeOverallPercent(scoresMap, groups) {
  let readiness = 0;
  let expected = 0;
  for (const { rows, overrides } of groups) {
    for (const row of rows) {
      const ai = scoresMap?.[row.id];
      const o = overrides?.[row.id];
      const rs = Number.isFinite(o?.readinessScore) ? o.readinessScore : aiRowHasScore(ai) ? ai.readinessScore : null;
      const es = Number.isFinite(o?.expectedScore) ? o.expectedScore : aiRowHasScore(ai) ? ai.expectedScore : null;
      if (Number.isFinite(rs) && Number.isFinite(es)) {
        readiness += rs;
        expected += es;
      }
    }
  }
  return expected > 0 ? Math.round((readiness / expected) * 100) : null;
}
